<template>
  <div class="flow-intro">
    <p class="has-text-weight-bold is-size-4">
      {{ $t("af:application.intro.title") }}
    </p>

    <p>{{ $t("af:application.intro.subtitle") }}</p>

    <div v-for="step in flowConfigSteps" :key="step.id" class="flow-step">
      <div class="flow-step__icon mr-2">
        <b-icon
          icon-pack="fa"
          :icon="step.stepIcon"
          type="is-grey-icon"
        ></b-icon>
      </div>

      <span class="has-text-weight-medium">{{ step.name }}</span>

      <span class="has-text-grey-icon ml-2">
        -
        <span class="pl-1"
          >{{ timeToAnswer(step.estimatedTimeToAnswerInSeconds) }}
          {{ $t("af:application.intro.label.step_unit") }}</span
        >
      </span>

      <b-tooltip
        class="ml-2"
        :label="step.description"
        type="is-tooltip"
        position="is-right"
      >
        <b-icon
          class="file-icon"
          icon-pack="fa"
          icon="info-circle"
          type="is-info"
        ></b-icon>
      </b-tooltip>
    </div>

    <div class="flow-step" v-if="isOnline">
      <div class="flow-step__icon mr-2">
        <b-icon icon-pack="fa" icon="video" type="is-grey-icon"></b-icon>
      </div>

      <span class="has-text-weight-medium">{{
        $t("af:application.intro.label.video_identification")
      }}</span>

      <span class="has-text-grey-icon ml-2">
        -
        <span class="pl-1">{{
          $t("af:application.intro.label.video_identification.duration")
        }}</span>
      </span>
    </div>

    <div class="flow-step" v-if="isOnline">
      <div class="flow-step__icon mr-2">
        <b-icon icon-pack="fa" icon="eye" type="is-grey-icon"></b-icon>
      </div>

      <span class="has-text-weight-medium">{{
        $t("af:application.intro.label.contract_check")
      }}</span>

      <span class="has-text-grey-icon ml-2">
        -
        <span class="pl-1">{{
          $t("af:application.intro.label.contract_check.duration")
        }}</span>
      </span>
    </div>

    <div class="flow-step" v-if="isOnline">
      <div class="flow-step__icon mr-2">
        <b-icon icon-pack="fa" icon="signature" type="is-grey-icon"></b-icon>
      </div>

      <span class="has-text-weight-medium">{{
        $t("af:application.intro.label.contract_sign")
      }}</span>

      <span class="has-text-grey-icon ml-2">
        -
        <span class="pl-1">{{
          $t("af:application.intro.label.contract_sign.duration")
        }}</span>
      </span>
    </div>

    <div class="flow-step">
      <div class="flow-step__icon mr-2">
        <b-icon icon-pack="fa" icon="gavel" type="is-grey-icon"></b-icon>
      </div>

      <span class="has-text-weight-medium">{{
        $t("af:application.intro.label.decision")
      }}</span>

      <span class="has-text-grey-icon ml-2">
        -
        <span class="pl-1">{{
          $t("af:application.intro.label.decision.duration")
        }}</span>
      </span>
    </div>

    <application-template
      template="APPLICATION_INTRO_BOTTOM"
    ></application-template>

    <b-button
      id="flowIntroButtonStart"
      type="is-blue"
      class="mt-6"
      @click="startFlow"
      >{{ $t("af:application.intro.button.start") }}</b-button
    >
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { FLOW_POSITION } from "../../utils/const";

export default {
  name: "ApplicationFlowIntro",
  components: {
    ApplicationTemplate: () => import("@/components/ApplicationTemplate.vue"),
  },
  props: {
    applicationId: {
      type: Number,
      required: true,
    },
    flowConfigSteps: {
      type: Array,
      required: true,
    },
    isOnline: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    ...mapActions({
      savePosition: "loanApplication/savePosition",
    }),
    timeToAnswer(seconds) {
      return Math.floor(seconds / 60);
    },
    async startFlow() {
      await this.savePosition({
        id: this.applicationId,
        flowPosition: FLOW_POSITION.FLOW,
        currentFlowStepIndex: 0,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.flow-step {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 1rem 0;

  .flow-step__icon {
    height: 40px;
    width: 40px;
    min-width: 40px;
    min-height: 40px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #dfe6ef;
  }
}

.flow-intro::v-deep {
  .required-documents {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 1rem;

    .required-document-tile {
      background: #f3f5f9;
      border-radius: 8px;
      text-align: center;
      padding: 10px 0;
    }
  }
}

@media only screen and (min-width: 769px) {
  .flow-intro::v-deep {
    .required-documents {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}
</style>
